import { createContext, ReactNode, useContext, useState } from 'react';

import { ProductWithAttributes } from '@gn-audio/jss-core';

interface ProductGroupContextValue {
  productGroup: ProductWithAttributes | null;
  setProductGroup: (group: ProductWithAttributes | null) => void;
}

const ProductGroupContext = createContext<ProductGroupContextValue | undefined>(undefined);

export const ProductGroupProvider = ({ children }: { children: ReactNode }) => {
  const [productGroup, setProductGroup] = useState<ProductWithAttributes | null>(null);

  return (
    <ProductGroupContext.Provider value={{ productGroup, setProductGroup }}>
      {children}
    </ProductGroupContext.Provider>
  );
};

export const useProductGroup = (): ProductGroupContextValue => {
  const context = useContext(ProductGroupContext);

  if (!context) {
    throw new Error('useProductGroup must be used within a ProductGroupProvider');
  }

  return context;
};
